import useShouldRender from "../components/useShouldRender";
import TaxOfficeHoursChange from "../news/TaxOfficeHoursChange";
import CouncilMeetingAgenda from "../news/CouncilMeetingAgenda";
import StockhamBuildingDocs from "../news/StockhamBuildingDocs";
import ReminderOpenBurning from "../news/ReminderOpenBurning";
import ReminderOutdoorFireplaces from "../news/ReminderOutdoorFireplaces";
import PCMeeting from "../events/PCMeeting";
import ZHBMeeting from "../events/ZHBMeeting";
import CivilServiceMtgEvent01 from "../events/CivilServiceMtgEvent01";
import NewsMS4StormWaterUpdate from "../news/NewsMS4StormWaterUpdate";
import FloodPlaneChangesNotice from "../news/FloodPlaneChangesNotice";
import MMAMeeting from "../events/MMAMeeting";
import NationalNightOut from "../events/NationalNightOut";
import LibraryClosedSept2026 from "../news/LibraryClosedSept2026";
import MeetingCouncilSpecial from "../events/MeetingCouncilSpecial";
import LibraryMeeting from "../events/LibraryMeeting";
import RequestingSOI from "../news/RequestingSOI";
import NewsLeafDropOff from "../news/NewsLeafDropOff";
import PolicyStatementHalloween from "../news/PolicyStatementHalloween";

const HomePageNewsAndEvents = () => {
  //Removals Start

  const showUntilJuly1st = useShouldRender("2026-07-01", "00:00");
  const showUntilReminderOpenBurningSept012026 = useShouldRender("2026-09-01", "00:00");
  const showUntilReminderOutdoorFireplacesSept012026 = useShouldRender("2026-09-01", "00:00");
  const showUntilPCMeeting = useShouldRender("2026-08-10", "20:00");
  const showUntilMMAMeeting = useShouldRender("2026-08-20", "20:00");
  const showUntilAugust1stMS4 = useShouldRender("2026-08-01", "00:00");
  const showUntilAugust4thNNO = useShouldRender("2026-08-04", "20:30");
  const showUntilOct1FloodPlain = useShouldRender("2026-10-01", "00:00");
  const showUntilSept21stPolice = useShouldRender("2026-09-21", "20:00");
  const showUntilOct20th2100CouncilMeeting = useShouldRender("2026-10-20", "21:00");
  const showUntilOct5at9pm = useShouldRender("2026-10-05", "21:00");
  const showUntilOct14at9pm = useShouldRender("2026-10-14", "21:00");
  const showUntilOct12at9pm = useShouldRender("2026-10-12", "21:00");
  const showUntilOct27at11am = useShouldRender("2026-10-27", "11:00");
  const showUntilDec13at1159pm = useShouldRender("2026-12-13", "11:59");
  const showUntilOct31at1159pm = useShouldRender("2026-10-31", "11:59");

  //Removals End

  return (
    <div>
      <div className="homepage-row">
        {/* START SPECIAL FEATURE AREA */}

        {/* END SPECIAL FEATURE AREA */}

        {/* START SNOW EMERGENCY AREA */}

        {/* END SNOW EMERGENCY AREA */}

        <div className="homepage-news-event-group">
          <div className="homepage-news-cell">
            <div className="homepage-title">Latest News</div>
            {/*Accordion Start - News */}
            <div className="accordion-container">
              <div className="accordion" id="latestNewsAccordion">
                {/* ADD IMPORTED NEWS BELOW */}

                {showUntilOct20th2100CouncilMeeting && (
                  <div>
                    {" "}
                    <CouncilMeetingAgenda />
                  </div>
                )}

                {showUntilOct31at1159pm && (
                  <div>
                    {" "}
                    <PolicyStatementHalloween />
                  </div>
                )}

                {showUntilDec13at1159pm && (
                  <div>
                    {" "}
                    <NewsLeafDropOff />
                  </div>
                )}

                {showUntilOct27at11am && (
                  <div>
                    {" "}
                    <RequestingSOI />
                  </div>
                )}

                <LibraryClosedSept2026 />

                {showUntilOct1FloodPlain && (
                  <div>
                    {" "}
                    <FloodPlaneChangesNotice />
                  </div>
                )}

                {showUntilAugust1stMS4 && (
                  <div>
                    {" "}
                    <NewsMS4StormWaterUpdate />
                  </div>
                )}

                {showUntilReminderOpenBurningSept012026 && (
                  <div>
                    {" "}
                    <ReminderOpenBurning />
                  </div>
                )}

                {showUntilReminderOutdoorFireplacesSept012026 && (
                  <div>
                    {" "}
                    <ReminderOutdoorFireplaces />
                  </div>
                )}

                {showUntilJuly1st && (
                  <div>
                    {" "}
                    <StockhamBuildingDocs />
                  </div>
                )}

                {showUntilJuly1st && (
                  <div>
                    {" "}
                    <TaxOfficeHoursChange />
                  </div>
                )}

                {/* END IMPORTED NEWS ITEMS */}
              </div>
            </div>
            {/*Accordion End - News*/}
          </div>
          {/*End News Side Of Page*/}
          {/*Start News Side Of Page*/}
          <div className="homepage-events-cell">
            <div className="homepage-title">Upcoming Events</div>
            {/*Accordion Start - Events*/}
            <div className="accordion-container">
              <div className="accordion" id="upcomingEventsAccordion">
                {/* ADD IMPORTED EVENTS BELOW */}

                {showUntilOct12at9pm && (
                  <div>
                    {" "}
                    <PCMeeting />
                  </div>
                )}

                {showUntilOct14at9pm && (
                  <div>
                    {" "}
                    <CivilServiceMtgEvent01 />
                  </div>
                )}

                {showUntilOct14at9pm && (
                  <div>
                    {" "}
                    <LibraryMeeting />
                  </div>
                )}

                {showUntilAugust4thNNO && (
                  <div>
                    {" "}
                    <NationalNightOut />
                  </div>
                )}

                {showUntilPCMeeting && (
                  <div>
                    {" "}
                    <PCMeeting />
                  </div>
                )}

                {showUntilSept21stPolice && (
                  <div>
                    {" "}
                    <CivilServiceMtgEvent01 />
                  </div>
                )}

                {showUntilMMAMeeting && (
                  <div>
                    {" "}
                    <MMAMeeting />
                  </div>
                )}

                {showUntilOct5at9pm && (
                  <div>
                    {" "}
                    <ZHBMeeting />
                  </div>
                )}

                {/* END IMPORTED EVENT ITEMS */}
              </div>
            </div>
            {/*Accordion End*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageNewsAndEvents;
